export class ScheduleTime {
    public id: number;
    public openingHour: string;
    public closingHour: string;
    public lunchStartHour: string;
    public lunchEndHour: string;
    public openingDays: string;
    public status: number;

    static convertObjectToTimeString(object: { hour: number, minute: number }): string {
        return (object.hour < 10 ? '0' + object.hour : object.hour) + ':' + (object.minute < 10 ? '0' + object.minute : object.minute);
    }

    static convertStringToObject(timeString: string): { hour: number, minute: number } {
        const timeArray = timeString.split(':');
        return {
            // tslint:disable-next-line:radix
            hour: parseInt(timeArray[0]),
            // tslint:disable-next-line:radix
            minute: parseInt(timeArray[1])
        };
    }

    static returnSumOfTime(object: { hour: number, minute: number }): number {
        return (object.hour * 60) + object.minute;
    }

    static convertDaysObjectToArray(object: { day: string, value: boolean }): string {
        let returnString = '';
        for (const key in object) {
            if (Object.prototype.hasOwnProperty.call(object, key)) {
                const element = object[key];
                returnString += (element ? '1' : '0');
            }
        }
        return returnString;
    }

    static convertDaysStringToObject(daysString: string): any {
        const daysArray = daysString.split('');
        return {
            '1': (daysArray[0] === '1' ? true : false),
            '2': (daysArray[1] === '1' ? true : false),
            '3': (daysArray[2] === '1' ? true : false),
            '4': (daysArray[3] === '1' ? true : false),
            '5': (daysArray[4] === '1' ? true : false),
            '6': (daysArray[5] === '1' ? true : false),
            '7': (daysArray[6] === '1' ? true : false)
        };
    }
}
